<i18n>
{
  "en": {
    "powerBiReportingTitle": "Power BI Reporting"
  },
  "es": {
    "powerBiReportingTitle": "Informes Power BI"
  }
}
</i18n>

<template>
  <v-container class="d-flex flex-column container"  style="height: 100%; width: 100%;">
    <div style="position: relative; height: 100%; width: 100%; margin-top: -40px;">
      <div class="hide-notification-bar"></div>
      <PowerBIReport style="height: 100%; width: 100%; padding-top: 0.5%"
        :powerBiParams="powerBiParams"
      />
    </div>
  </v-container>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import DynameatSkeleton from '@dynameat/components/DynameatSkeleton';
import PowerBIReport from './components/PowerBIReport.vue';

@Component
@Components({
  PowerBIReport,
  DynameatSkeleton
})
@MapActions(['powerBiParamsRequest'])
@MapGetters(['powerBiParams'])
export default class PowerBIReporting extends Vue {
  async created() {
    await this.powerBiParamsRequest();
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
}

.carousel-container {
  display: flex;
  flex: 1;

  > :first-child {
    display: flex;
    flex: 1;

    > div {
      display: flex;
      flex: 1;
    }
  }
}
.hide-notification-bar {
  background-color: #fff;
  width: 100%;
  height: 62px;
  position: absolute;
}
</style>
